export const SET_NOTIFICATION_TAGS = 'NOTIFICATIONS/SET_NOTIFICATION_TAGS';
export const SET_NOTIFICATION_CATEGORIES = 'NOTIFICATIONS/SET_NOTIFICATION_CATEGORIES';
export const SET_CURRENT_NOTIFICATION_CATEGORY = 'NOTIFICATIONS/SET_CURRENT_NOTIFICATION_CATEGORY';